import ContactButton from 'components/elements/buttons/ContactButton'
import CallModal from 'components/elements/modal/CallModal'
import React from 'react'
import styled from 'styled-components'

/**
 * 横長の架電ボタン表示エリア
 */
const ContactArea: React.FC<ContactAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.showContact && (
        <StyledContactArea>
          <CallModal isTransitionReAccess={false}>
            <ContactButton />
          </CallModal>
        </StyledContactArea>
      )}
    </React.Fragment>
  )
}

export type ContactAreaProps = {
  showContact?: boolean
}

const StyledContactArea = styled.div`
  margin: 32px 8px;
  text-align: center;
`

export default ContactArea
